import useBreakpointOriginal from 'use-breakpoint';
import { BREAKPOINTS, Breakpoint } from '../theme/breakpoints';

/**
 * A custom hook that returns the current breakpoint based on the window size.
 *
 * @param fallback - The fallback value to return if the `window` object is not available.
 * @returns The current breakpoint based on the window size.
 * @see {@link BREAKPOINTS} for the defined breakpoints.
 * @see {@link Breakpoint} for the type of the breakpoints.
 * @see {@link useBreakpointOriginal} for the original hook from the `use-breakpoint` library.
 */
export const useBreakpoint = (fallback: Breakpoint = 'base'): Breakpoint => {
  /**
   * Check if the `window` object is available and if the `matchMedia` function is defined.
   * This is important for tests and server-side rendering (SSR) where the `window` object is not available.
   */
  const canUseMatchMedia =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function';

  if (!canUseMatchMedia) {
    return fallback;
  }

  return useBreakpointOriginal(BREAKPOINTS, fallback).breakpoint as Breakpoint;
};
